<template>
    <div class="ly-cascader">
        <Cascader :data="bindData"
             v-model="bindValue" 
             @on-change="handleChange" 
             filterable 
             change-on-select 
             :load-data="loadData"
             ref="cascader"></Cascader>
        <Spin fix v-if="isLoading"></Spin>
    </div>
</template>
<script>
    /**
     * 级联选择
     * value的值为数组［ ‘一级value’， ‘二级value’］
     */
    export default {
        name: 'LyCascader',
        props: {
            value: {
                type: [Object, Array, String],
                default: _ => []
            },
            /**
             * {
             *      isLoacalSave: false // 为true，表示本地化缓存数据
             * }
             */
            attrs: {
                type: Object,
                default: _ => new Object()
            },
            initData: { // 外面传入绑定数据,主要用语cacader-check中共享数据
                type: Array,
                default: _ => []
            }
        },
        data () {
            return {
                isInitBind: false, // 标识是否初始化绑定过了
                isLoading: false, // 是否加载中
                bindValue: [],
                bindData: [], // 绑定对象的数据
                itemList: []
            }
        },
        watch: {
            value: {
                handler () {
                    this.setBindValue()
                },
                immediate: true
            }
        },
        created () {
            this.initItemList()
        },
        mounted () {
            let _ = this.$refs.cascader
            // 覆盖iview cascader的handleSelectItem函数
            _.handleSelectItem = function (index) {
                const item = _.querySelections[index];
                if (item.item.disabled) return false;
                _.query = '';
                _.$refs.input.currentValue = '';
                const oldVal = JSON.stringify(_.currentValue);
                _.currentValue = item.value.toString().split(','); // item.value为数组，转换为字符串 2020-12-1 by wxf
                _.emitValue(_.currentValue, oldVal);
                _.handleClose();
                // 以上拷贝于iview的源码
                // 以下是真对，搜索选择显示不正确的处理
                this.$nextTick(() => {
                    // 显示的文字与当前选中的不一样时，重新设置selected的值
                    if (_.displayRender != item.label) {
                        let arr = []
                        item.label.split(' / ').forEach(el => {
                            arr.push({
                                label: el
                            })
                        })
                        _.selected = arr
                        console.log('select:%O', _.selected)
                    }
                })
            }
        },
        methods: {
            /**
             * 初始化选择项
             */
            initItemList () {
                if (this.attrs.api) {
                    this.isLoading = true
                    let localData = ''
                    // 是否开启了本地存储
                    if (this.attrs.isLoacalSave) {
                        localData = localStorage.getItem(this.attrs.api)
                    }
                     // 获取本定存储的数据
                    if (localData && localData.length > 0 ) {
                        this.initBindValue(JSON.parse(localData))
                    } else {
                        let url = this.attrs.api
                        let path = this.$path.getPath(url, this.$route.params, 'GET') // 路由中拿到参数
                        this.$api.query(path).then((rs) => {
                            this.initBindValue(rs)
                            // 是否开启了本地存储
                            if (this.attrs.isLoacalSave) {
                                // 本地存储获得的数据，使用api的地址当key
                                localStorage.setItem(this.attrs.api,  JSON.stringify(rs))
                            }
                        }).catch((err) => {
                            console.error(err)
                            this.isLoading = false
                        })
                    }
                }
            },
            /**
             * 设置绑定的值
             */
            initBindValue (rs) {
                this.itemList = rs
                // 如果有共享数据，不进行筛选绑定
                if (this.initData.length > 0) {
                    this.bindData = this.initData
                } else {
                    // 初始化设置绑定的值，将以及菜单的值，绑定
                    for (let i = 0, len = rs.length; i < len; i++) {
                        let item = JSON.parse(JSON.stringify(rs[i]))
                        // 设置只取二级
                        if(item.children && item.children.length > 0) { // 增加判断，有些区域不显示二级城市 modify by wxf 2021-08-03
                            for (let j = 0, jlen = item.children.length; j < jlen; j++) {
                                item.children[j] = {
                                    ...item.children[j],
                                    p_index: i,
                                    index: j
                                }
                                // 有第三级在加入loading标识 【cpc 客户选择 三级联需要展示全，需注释下段代码发布 2020-12-1 by wxf
                                // if (item.children[j]['children'] && item.children[j]['children'].length > 0) {
                                //     item.children[j]['loading'] = false
                                //     item.children[j]['children'] = []
                                // }
                            }
                        }
                        this.bindData.push(item)
                    }
                }
                this.$nextTick(() => {
                    this.isLoading = false
                })
            },
            /**
             * 设置绑定的值
             */
            setBindValue () {
                if (!this.value || this.isInitBind) return
                for (let i = 0, len = this.value.length; i < len; i++) {
                    if (this.value[i] != this.bindValue[i]) {
                        // this.$set(this.bindValue, i, this.value[i])
                        this.$set(this.bindValue, i, parseInt(this.value[i]))//update by wxf 2019-10-14 解决回填数据不显示
                        this.isInitBind = true
                    }
                }
            },
            /**
             * 选择的监听
             */
            handleChange (val) {
                this.$emit('input', val)
                let index = 0
                for(let i = 0; i < this.itemList.length; i++) {
                    if(val[0] == this.itemList[i].value) {
                        index = i
                    }
                }
                // 解决搜索是val为空的bug 2020-12-1 by wxf
                // if(val !== undefined) { 
                if(val !== undefined) { 
                    if(this.attrs.isTxtLink) { // set 联动赋值
                        if(val.length > 0) {                            
                            this.$eventHub.$emit(this.attrs.field + "LinkEvent", this.itemList[index])// 全局监听 modify by wxf 2020-11-20
                        } else {
                            this.$eventHub.$emit(this.attrs.field + "LinkEvent", {})// 清空数据 modify by wxf 2020-12-14
                        }
                    }                     
                }                   
            },
            /**
             * 异步加载子选项数据
             */
            loadData (item, callback) {
                console.log(item)
                this.$set(item, 'loading', true)                           
                // item.loading = true
                // 取得对应索引下的子选项
                if (item.index >= 0) {
                    let arr = this.itemList[item.p_index]['children'][item.index]['children']
                    item.children = arr
                    this.$nextTick(() => {
                        
                        setTimeout(() => {
                            item.loading = false
                            callback()
                        }, 300)
                    })
                }
            } 
        }
    }
</script>

<style>
    .ly-cascader {
        position: relative;
    }
</style>


// WEBPACK FOOTER //
// ../projectCore/src/components/cascader/src/index.vue